import { render, staticRenderFns } from "./verification-sheet.vue?vue&type=template&id=2b8a604b&scoped=true"
import script from "./verification-sheet.vue?vue&type=script&lang=js"
export * from "./verification-sheet.vue?vue&type=script&lang=js"
import style0 from "./verification-sheet.vue?vue&type=style&index=0&id=2b8a604b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8a604b",
  null
  
)

export default component.exports